
import React from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { DocumentProps } from "@/hooks/admin/identity-docs/useSubmittedDocuments";

interface DocumentApprovalDialogComponentProps {
  document: DocumentProps;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  approvalNotes: string;
  onApprovalNotesChange: (notes: string) => void;
  onApprove: () => void;
}

export function DocumentApprovalDialogComponent({
  document,
  open,
  onOpenChange,
  approvalNotes,
  onApprovalNotesChange,
  onApprove
}: DocumentApprovalDialogComponentProps) {
  const isExpired = document.expiry_date && new Date(document.expiry_date) < new Date();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isExpired ? "Document Expired" : "Approve Document"}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {isExpired ? (
              <div className="text-amber-600 font-semibold mb-2">
                Warning: This document appears to be expired. Approval is not recommended.
              </div>
            ) : (
              "Are you sure you want to verify this document?"
            )}
            
            <div className="mt-4 space-y-4">
              <div>
                <label htmlFor="approval-notes" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Notes (Optional)
                </label>
                <textarea 
                  id="approval-notes"
                  value={approvalNotes}
                  onChange={(e) => onApprovalNotesChange(e.target.value)}
                  className="w-full p-2 border rounded-md text-sm"
                  placeholder="Add any notes about this verification"
                  rows={3}
                />
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onApprove}>
            Approve Document
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
